"use client";

import React, { useEffect, useRef, useState } from "react";

// Renders `children` only once the placeholder is within `rootMargin` of the viewport. For sections far
// below the fold whose first render is expensive (e.g. a Swiper with ~100 slides) and whose content is not
// in the server HTML anyway, so deferring them costs no SEO content. The placeholder reserves `minHeight`
// so the swap doesn't move whatever sits below it; browsers without IntersectionObserver mount at once.
export default function MountWhenVisible({ children, minHeight = 0, rootMargin = "600px 0px" }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (visible) return undefined;
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setVisible(true);
          io.disconnect();
        }
      },
      { rootMargin }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [visible, rootMargin]);

  return visible ? children : <div ref={ref} style={{ minHeight }} aria-hidden="true" />;
}
